import * as types from "./actionTypes";
import { showModalSuccess, hideModalSuccess } from "./modalActions";
import { showAlertSuccess } from "./alertActions";
import departmentService from "../services/departmentService";

export function loadDepartmentSuccess(departments) {
  return {
    type: types.LOAD_DEPARTMENT_SUCCESS,
    departments,
    meta: {
      throttle: true
    }
  };
}

export function getDepartmentSuccess(department) {
  return {
    type: types.GET_DEPARTMENT_SUCCESS,
    department
  };
}

export function savingDepartment(status = true) {
  return {
    type: types.SAVING_DEPARTMENT,
    savingDepartment: status
  };
}

export function loadDepartments() {
  return (dispatch) =>
    departmentService
      .loadDepartments()
      .then((data) => dispatch(loadDepartmentSuccess(data)))
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
}

export function getDepartment(id, showDEPARTMENTDetails = false) {
  return (dispatch) =>
    departmentService
      .getDepartment(id)
      .then((department) => {
        dispatch(getDepartmentSuccess(department));
        if (showDEPARTMENTDetails) {
          dispatch(showModalSuccess("departmentDetailsModal"));
        }
      })
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
}

export function updateDepartmentSuccess(department) {
  return {
    type: types.UPDATE_DEPARTMENT_SUCCESS,
    department
  };
}

export function updateDepartment(id, department) {
  return (dispatch) => {
    dispatch(savingDepartment());
    return departmentService
      .updateDepartment(id, department)
      .then((updatedDepartment) => {
        dispatch(updateDepartmentSuccess(updatedDepartment));
        dispatch(savingDepartment(false));
        dispatch(hideModalSuccess("departmentDetailsModal"));
        dispatch(
          showAlertSuccess("Department updated successfully", "success")
        );
      })
      .catch((error) => {
        dispatch(savingDepartment(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}
